/** Strip leaked prompt/thinking wrappers from assistant text (stream + history). */
export function sanitizeAiAnswerText(text: string, opts?: { trim?: boolean }): string {
  if (!text) return '';
  let cleaned = text
    .replace(/\[Chuyên gia\s+[\w.]+\]/gi, '')
    .replace(/\[chuyen gia\s+[\w.]+\]/gi, '')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/<think>[\s\S]*?<\/redacted_thinking>/gi, '')
    .replace(/<thinking>[\s\S]*?<\/thinking>/gi, '')
    .replace(new RegExp(`<${'think'}>[\\s\\S]*?</${'think'}>`, 'gi'), '')
    .replace(/<<<SOURCE_NOTES>>>[\s\S]*?<<<END_SOURCE_NOTES>>>/gi, '')
    .replace(/<<<SOURCE_NOTES>>>[\s\S]*$/gi, '')
    .replace(/<<<END_SOURCE_NOTES>>>/gi, '')
    .replace(/<untrusted\b[^>]*>[\s\S]*?<\/untrusted>/gi, '')
    .replace(/<\/?untrusted[a-z0-9_-]*\b[^>]*>/gi, '')
    // Truncated stubs only (keep following text): <untrustedD, </untrusted
    .replace(/<\/?untrusted[a-z0-9_-]*/gi, '')
    .replace(/<(think|thinking)>[\s\S]*$/gi, '');
  return opts?.trim === false ? cleaned : cleaned.trim();
}
